export const API_CONFIG = {
  BASE_URL: 'https://neetmocktest.mystudyplace.online/backend/',

  ENDPOINTS: {
    USERDATA: 'UserData.php',
    LOGINUPDATE: 'LoginUpdate.php',
    SIGNUP: 'SignUp.php',
    PUSHDATA: 'PushData.php',
    UPDATEPROFILE: 'UpdateProfile.php',
    DELETEACCOUNT: 'DeleteAccount.php',
    USERBEFORELOGIN: 'UserBeforeLogin.php',
    USERDOUBTSEND: 'UserDoubtSend.php',
    USERDOUBT: 'UserDoubt.php',
    APPINSTALLSEND: 'AppInstallSend.php',
    USERAPPINSTALL: 'UserAppInstall.php',
    APPITEMSUSEPUSH: 'AppItemsUsePush.php',
    APPITEMSUSEFETCH: 'AppItemsUseFetch.php',
    PAYMENTITEMS: 'PaymentItems.php',
    PAYRAZORPAY: 'PayRazorpay.php',
    ALLPAYMENTS: 'AllPayments.php',
    GATEPAYMENTS: 'GatePayments.php',
    GATEPAYMENTREFUND: 'GatePaymentRefund.php',
    STUDENTMESSAGE: 'StudentMessage.php',
    STUDENTFEEDBACK: 'StudentFeedback.php',
    STUDENTFEEDBACKREAD: 'StudentFeedbackRead.php',
    STUDENTFEEDBACKLISTREAD: 'StudentFeedbackListRead.php',
    SUBCRIPTIONOFFERTIME: 'SubcriptionOfferTime.php',
    PAYMENTREFUNDEDREAD: 'PaymentRefundedRead.php',
    
  }   
};

